import { cloneDeep } from 'lodash'
import { dateRenderer } from '@/lib/generic.utils'
import { dateColumn, renderEndDate, planWorkflowCol } from '@/lib/reusable-ag-grid-columns'
// Components
import AgGridToggle from '@components/ag-grid-helpers/AgGridToggle'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import AgGridTextDateFilter from '@components/ag-grid-helpers/AgGridTextDateFilter'

export default {
  computed: {
    gridOptions() {
      return {
        context: {
          actions: [
            {
              label: 'Start',
              onClick: this.startWorkflow,
              color: 'positive',
              tooltip: 'Start the workflow for the subscription period - enters the next available task',
              tooltipStyle: { fontSize: '13px' }
            },
            {
              label: 'Cancel',
              onClick: this.cancelWorkflow,
              color: 'deep-orange-4',
              tooltip: 'Cancel the subscription period - enters the Place orders task as a cancellation',
              tooltipStyle: { fontSize: '13px' }
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            filter: 'agTextColumnFilter',
            sortable: true,
            pinned: 'left',
            headerClass: 'header-cell',
            minWidth: 80,
            maxWidth: 160
          },
          {
            headerName: 'Product type',
            field: 'subscription.product.product_type.name',
            tooltipField: 'subscription.product.product_type.name',
            filter: 'agTextColumnFilter',
            sortable: true,
            pinned: 'left',
            headerClass: 'header-cell',
            hide: true,
            minWidth: 50,
            maxWidth: 160
          },
          dateColumn({
            headerName: 'Start date',
            field: 'start_date',
            sortable: true,
            pinned: 'left',
            headerClass: 'header-cell',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            valueGetter: params => {
              if (!params.data) return
              return dateRenderer(params.data.start_date)
            },
            cellRenderer: params => dateRenderer(params.data.start_date),
            tooltipValueGetter: params => {
              if (!params.data) return
              return dateRenderer(params.data.start_date)
            },
            minWidth: 100,
            maxWidth: 160
          }),
          dateColumn({
            headerName: 'End date',
            field: 'end_date',
            sortable: true,
            filter: 'agTextColumnFilter',
            pinned: 'left',
            headerClass: 'header-cell',
            cellRenderer: renderEndDate,
            tooltipValueGetter: renderEndDate,
            valueGetter: renderEndDate,
            minWidth: 100,
            maxWidth: 160
          }),
          {
            headerName: 'Publisher',
            field: 'publisher.name',
            tooltipField: 'publisher.name',
            filter: 'agTextColumnFilter',
            sortable: true,
            pinned: 'left',
            headerClass: 'header-cell',
            minWidth: 100,
            maxWidth: 160
          },
          {
            headerName: 'Vendor',
            field: 'vendor.name',
            tooltipField: 'vendor.name',
            valueFormatter: params => params.value || 'N/A',
            filter: 'agTextColumnFilter',
            sortable: true,
            pinned: 'left',
            headerClass: 'header-cell',
            hide: true,
            minWidth: 100,
            maxWidth: 160
          },
          planWorkflowCol.call(this, 'plan_workflow_applicable', {
            headerName: 'Plan Workflow',
            field: 'plan_workflow'
          }),
          planWorkflowCol.call(this, 'request_prices_applicable', {
            headerName: 'Request Price',
            field: 'request_prices'
          }),
          planWorkflowCol.call(this, 'price_entries_applicable', {
            headerName: 'Price Entry',
            field: 'price_entries'
          }),
          planWorkflowCol.call(this, 'stakeholders_applicable', {
            headerName: 'Stakeholders',
            field: 'stakeholders'
          }),
          planWorkflowCol.call(this, 'evaluations_applicable', {
            headerName: 'Evaluation',
            field: 'evaluations'
          }),
          planWorkflowCol.call(this, 'decisions_applicable', {
            headerName: 'Decision',
            field: 'decisions'
          }),
          planWorkflowCol.call(this, 'place_orders_applicable', {
            headerName: 'Place Orders',
            field: 'place_orders'
          }),
          planWorkflowCol.call(this, 'approve_invoices_applicable', {
            headerName: 'Approve Invoices',
            field: 'approve_invoices'
          }),
          planWorkflowCol.call(this, 'vendor_payments_applicable', {
            headerName: 'Vendor Payments',
            field: 'vendor_payments'
          }),
          planWorkflowCol.call(this, 'implementations_applicable', {
            headerName: 'Implementation',
            field: 'implementations'
          }),
          planWorkflowCol.call(this, 'inform_users_applicable', {
            headerName: 'Inform Users',
            field: 'inform_users'
          }),
          {
            headerName: 'All Tasks',
            colId: 'all_tasks',
            cellRendererParams: params => {
              const rowId = params.data.id
              const rowTasks = params.data.task_applicability
              return {
                getFromValue: true,
                handleToggleOnParent: val => {
                  const tasks = cloneDeep(this.tasks.get(rowId) || rowTasks)
                  tasks.forEach(task => (task.value = val))
                  this.tasks.set(rowId, tasks)
                  this.onCellToggle(params.data.id, tasks)
                }
              }
            },
            valueGetter: params => {
              if (!params.data) return
              return {
                val: this.isRowToggledToTrue(params),
                key: 'allTasks'
              }
            },
            cellRendererFramework: AgGridToggle,
            lockVisible: true,
            headerClass: 'task-header-cell',
            minWidth: 65,
            maxWidth: 90
          },
          {
            headerName: 'Actions',
            cellRendererFramework: LmEntityActions,
            lockVisible: true,
            pinned: 'right',
            lockPinned: true,
            headerClass: 'header-cell',
            minWidth: 150,
            maxWidth: 150
          }
        ],
        frameworkComponents: {
          agDateInput: AgGridTextDateFilter,
          AgGridTextDateFilter
        },
        headerHeight: 120,
        defaultColDef: {
          floatingFilter: true,
          filter: false,
          sortable: false,
          suppressMenu: true
        },
        cacheBlockSize: 30,
        pagination: false,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        domLayout: 'normal'
      }
    }
  }
}
